import { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import styled from 'styled-components'
import axios from '../../api/axios'
import { portalState } from '../../hooks/usePortal'
import { ErrorMsg } from './styles'

const Background = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`

const Card = styled.section`
    background: ${({ theme }) => theme.area?.background || '#fff'};
    border: 1px solid ${({ theme }) => theme.border?.color || '#e5e7eb'};
    border-radius: 0.75rem;
    padding: 2rem;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
`

const Title = styled.h2`
    margin: 0;
    font-size: 1.2rem;
`

const Description = styled.p`
    margin: 0;
    font-size: 0.95rem;
    color: ${({ theme }) => theme.font?.muted || '#6b7280'};
`

const Button = styled.button`
    padding: 0.65rem 1rem;
    background: ${({ theme }) => theme.button?.primary?.background || '#2563eb'};
    color: ${({ theme }) => theme.button?.primary?.color || '#fff'};
    border: none;
    border-radius: 0.5rem;
    font-size: 1rem;
    cursor: pointer;

    &:disabled { opacity: 0.6; cursor: not-allowed; }
`

const AcceptJoinOrganization = () => {
    const { token } = useParams()
    const navigate = useNavigate()
    const snap = useSnapshot(portalState)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const orgName = snap.name || snap.contactName || 'the organization'

    const handleAccept = async () => {
        setLoading(true)
        setError(null)
        try {
            await axios.post('/portal/acceptJoinOrganization', { token })
            navigate('/loggedout', { state: { message: 'portal.join.accepted' } })
        } catch (err) {
            setError(err.response?.data?.error?.name || 'error.unknown')
            setLoading(false)
        }
    }

    return (
        <Background>
            <Card>
                <Title>Join {orgName}</Title>
                <Description>
                    You have been invited to join <strong>{orgName}</strong>.
                    Click the button below to accept the invitation.
                </Description>
                {error && <ErrorMsg>{error}</ErrorMsg>}
                <Button onClick={handleAccept} disabled={loading}>
                    {loading ? 'Accepting...' : 'Accept Invitation'}
                </Button>
            </Card>
        </Background>
    )
}

export default AcceptJoinOrganization
